import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroActuariosParams, BuscarLibroActuariosResponse, defaultBuscarLibroActuariosResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroActuariosInterface';

export const ObtenerLibroActuarios = ( params: BuscarLibroActuariosParams ) => {

    return new Promise<BuscarLibroActuariosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroActuarios/ObtenerLibroActuarios', params, token)
            .then(({ data }: { data: BuscarLibroActuariosResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroActuariosResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroActuarios = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroActuarios/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroActuarios = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroActuarios/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
